














import { Component, Vue } from "vue-property-decorator";
@Component
export default class download extends Vue {
  mounted() {}
  goDownLoad() {
    let ua = navigator.userAgent;
    if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      window.location.href =
        "itms-apps://apps.apple.com/cn/app/%E8%BD%A6%E8%AE%AF%E7%BD%91/id577675997";
    } else {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.chexun.platform";
    }
  }
}
